import React from 'react';

import { useField } from 'formik';

import { twMerge } from 'tailwind-merge';

import FileInput from 'components/file-input/file-input';
import type { SupportedFilesTypes } from 'components/file-input/supportedfileTypes';

import Typography from 'components-new/typography/typography';

interface FileInputFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label: string;
  name: string;
  fileNameAreaClassName?: string;
  supportedFileTypes?: SupportedFilesTypes[];
  resetAfterSubmit?: boolean;
  onResetFile?: () => void;
  wrapperClassName?: string;
}

const FileInputField: React.FC<FileInputFieldProps> = (props) => {
  const {
    name,
    label,
    fileNameAreaClassName,
    supportedFileTypes,
    resetAfterSubmit,
    onResetFile,
    wrapperClassName,
    ...inputFieldProps
  } = props;
  const [field, meta] = useField(name);

  const labelAreaClassNames = twMerge(
    fileNameAreaClassName,
    meta.error && meta.touched && ' border-tomato-red bg-tomato-redLight',
  );

  return (
    <>
      <FileInput
        name={field.name}
        label={label}
        fileNameAreaClassName={labelAreaClassNames}
        supportedFileTypes={supportedFileTypes}
        resetAfterSubmit={resetAfterSubmit}
        wrapperClassName={wrapperClassName}
        onResetFile={onResetFile}
        {...inputFieldProps}
      />
      {meta.error && meta.touched && (
        <Typography
          as="p"
          variant="body-medium"
          className={twMerge('text-destructive mt-1')}
        >
          {meta.error}
        </Typography>
      )}
    </>
  );
};

export default FileInputField;
